import React from "react";

import IconUndo from "../../icons/toolbar/common/actions/Undo";
import IconRedo from "../../icons/toolbar/common/actions/Redo";
import Button from "react-bootstrap/Button";

import Range from "./Range";

export default class Actions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps;
  }

  _handleAddText() {
    this.props.onAddTextClicked();
  }

  _handleDeleteText() {
    this.props.onDeleteTextClicked();
  }

  _getAdjustmentValue(){
    var percentage = ((this.props.value - this.props.min) * 100) / (this.props.max - this.props.min);
    if (percentage > 50) {
        percentage = (percentage - 50) * 2; 
        if (percentage > 100) {
            percentage = 100;
        }
    } else {
        percentage = (percentage - 50) * 2;
        if (percentage < -100) {
            percentage = -100;
        }
    }
    return percentage;
  }

  render() {
    const { text } = this.props;

    const buttonText = text ? "Delete Text" : "+ Add Text";

    return (
      <div className="common actions">
        <div className="row align-items-center justify-content-between">
          <div className="col-auto">
            <button
              style={{ backgroundColor: "transparent", borderWidth: 0, marginTop: 20 }}
              disabled={!this.props.undoDisabled}
              onClick={() => {
                this.props.onUndoClicked();
              }}
            >
              <IconUndo disabled={!this.props.undoDisabled} className="my-3" />
            </button>
          </div>
          {this.props.showAddButton && (
            <div className="col">
              <Button
                variant="dark"
                size="sm"
                onClick={() => {
                  if (text) {
                    this._handleDeleteText();
                  } else {
                    this._handleAddText();
                  }
                }}
              >
                {buttonText}
              </Button>
            </div>
          )}
          {this.props.showApplyButton && (
            <div className="col text-center">
              <Button
                variant="dark"
                size="sm"
                onClick={() => this.props.onApplyClicked()}
              >
                Apply
              </Button>
            </div>
          )}
          {this.props.showInputRange && (
            <div className="col text-center">
              {this.props.adjustment && <div className="m-auto">{Math.round(this._getAdjustmentValue())}</div>}
              {!this.props.adjustment && <div className="m-auto">{Math.round(this.props.value * 100)}</div>}
              <Range
                value={this.props.value}
                min={this.props.min}
                max={this.props.max}
                step={this.props.step}
                onChange={(e) => {
                  this.props.onValueChange(e.target.value);
                }}
              />
            </div>
          )}
          <div className="col-auto">
            <button
              style={{ backgroundColor: "transparent", borderWidth: 0, marginTop: 20 }}
              disabled={!this.props.redoDisabled}
              onClick={() => {
                this.props.onRedoClicked();
              }}
            >
              <IconRedo disabled={!this.props.redoDisabled} className="" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}
